export default __webpack_public_path__ + "static/media/key.41755b97.svg";